import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';

import Table, { DataTableLineTotals as Totals } from '../../components/Table/Table';
import {
    PAGE,
    TOTAL_ELEMENTS,
    TOTAL_PAGES,
} from '../../components/Table/Utils';

import { numberFormat } from '../../helper/MaskHelper';

import { 
    ButtonNewTabCandidatosPorDataInicioInscricaoAndStatus, 
    ButtonNewTabCandidatosPorDataFinalizacaoInscricaoAndStatus 
} from '../Buttons/ButtonsNewTab';

export class DadosInscricoes extends Component {
    constructor (props) {
        super(props)
        this.state = {
            page: PAGE,
            size: 25,
            totalElements: TOTAL_ELEMENTS,
            totalPages: TOTAL_PAGES,
        }
    }

    sumCandidatosIniciaramInscricao = () => this.props.inscricoes.reduce((total, i) => total + i.candidatosIniciaramInscricao, 0);
    sumCandidatosAguardandoPagamento = () => this.props.inscricoes.reduce((total, i) => total + i.candidatosAguardandoPagamento, 0);
    sumCandidatosNaoFinalizados = () => this.props.inscricoes.reduce((total, i) => total + i.candidatosNaoFinalizados, 0);
    sumCandidatosFinalizaramInscricao = () => this.props.inscricoes.reduce((total, i) => total + i.candidatosFinalizaramInscricao, 0);

    handlePage = (value) => this.setState({ ...this.state, page: value, });
    handleRowsPerPage = (value) => this.setState({ ...this.state, size: value, page: 0, });
    handleTotalPages = () => Math.ceil(this.props.inscricoes.length / this.state.size);
    handleTotalElements = () => this.props.inscricoes.length;

    newTabCandidatosPorDataInicioInscricaoAndStatus = (qtd, data, status, query = "") => <ButtonNewTabCandidatosPorDataInicioInscricaoAndStatus qtd={numberFormat(qtd)} data={data} status={status} query={query} />
    newTabCandidatosPorDataFinalizacaoInscricaoAndStatus = (qtd, data, status, query = "") => <ButtonNewTabCandidatosPorDataFinalizacaoInscricaoAndStatus qtd={numberFormat(qtd)} data={data} status={status} query={query} />  

    render () {
        const columns = [
            { label: 'Data', name: 'dataFormatada', func: null, key: true, width: '20', orderLabel: 'desc', },
            { label: 'Inscrições Incompletas', name: 'candidatosIniciaramInscricao', func: (qtd, data) => this.newTabCandidatosPorDataInicioInscricaoAndStatus(qtd, data, "INICIADO"), key: false, width: '20', },
            { label: 'Inscrições Aguardando Pagamento', name: 'candidatosAguardandoPagamento', func: (qtd, data) => this.newTabCandidatosPorDataInicioInscricaoAndStatus(qtd, data, "AGUARDANDO_PAGAMENTO"), key: false, width: '20', },
            { label: 'Inscrições Não Finalizadas', name: 'candidatosNaoFinalizados', func: (qtd, data) => this.newTabCandidatosPorDataInicioInscricaoAndStatus(qtd, data, "INCOMPLETO", "&comEscolaSelecionada=true&comLocalProvaSelecionado=true"), key: false, width: '20', },
            { label: 'Inscrições Finalizadas', name: 'candidatosFinalizaramInscricao', func: (qtd, data) => this.newTabCandidatosPorDataFinalizacaoInscricaoAndStatus(qtd, data, "FINALIZADO"), key: false, width: '20', },
        ];
        
        const actions = [];

        const totals = [
            { column: 0, value: "Total", width: '20', },
            { column: 1, value: numberFormat(this.sumCandidatosIniciaramInscricao()), width: '20', },
            { column: 2, value: numberFormat(this.sumCandidatosAguardandoPagamento()), width: '20', },
            { column: 3, value: numberFormat(this.sumCandidatosNaoFinalizados()), width: '20', },
            { column: 4, value: numberFormat(this.sumCandidatosFinalizaramInscricao()), width: '20', },
        ];

        return (
            <Grid container spacing={3} style={{ marginTop: this.props.marginTop ?? 8 }}>
                <Grid item xs={12}>
                    <Table
                        columns={columns}                        
                        tableData={this.props.inscricoes.slice(this.state.page * this.state.size, (this.state.page * this.state.size) + this.state.size)}
                        actions={actions}
                        page={this.state.page}
                        handlePage={this.handlePage}
                        handleTotalPages={this.handleTotalPages}
                        handleTotalElements={this.handleTotalElements}
                        rowsPerPage={this.state.size}
                        handleRowsPerPage={this.handleRowsPerPage}
                        sort={null}
                        fixedHeader={true}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Totals lineData={totals} columns={columns} />
                </Grid>
            </Grid>
        )
    }
}

export default DadosInscricoes;